import { render, staticRenderFns } from "./AscPowerBiWorkspaceGrid.vue?vue&type=template&id=8defa2fe&"
import script from "./AscPowerBiWorkspaceGrid.vue?vue&type=script&lang=js&"
export * from "./AscPowerBiWorkspaceGrid.vue?vue&type=script&lang=js&"
import style0 from "./AscPowerBiWorkspaceGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports